import fp from 'lodash/fp';
import { LOCATION_CHANGE } from 'react-router-redux';
import { handleActions } from 'redux-actions';
import { configurations } from './configurations';

export const initialState = {
  createTask: undefined,
  isFetching: false,
  isFetchingBusinessTasks: false,
  isAssigningTask: false,
  tasks: [],
  teamTasks: [],
  businessTasks: [],
  taskedContents: [],
  task: undefined,
  taskCount: 0,
  completedTasks: [],
  history: [],
  isFetchingHistory: false,
  setTaskSuccess: undefined,
  isSendingReminder: false,
  businessSyncStatus: 'IDLE',
  teamSyncStatus: 'IDLE',
  isTriggeringBusinessSync: false,
  isTriggeringTeamSync: false,
  businessEmailJobStatuses: []
};

const reducer = handleActions(
  fp.flow(
    fp.map(
      ({
        reducers: { reducer, request, success, failed },
        action: {
          task: { api, ...action }
        },
        name
      }) => {
        var result = {};
        if (reducer) {
          result = {
            ...result,
            [action[name]().type]: reducer
          };
        }
        if (request) {
          result = {
            ...result,
            [api[name].request]: request
          };
        }
        if (success) {
          result = {
            ...result,
            [api[name].success]: success
          };
        }
        if (failed) {
          result = {
            ...result,
            [api[name].failed]: failed
          };
        }
        return result;
      }
    ),
    fp.reduce(
      (prev, current) => ({
        ...prev,
        ...current
      }),
      {}
    ),
    (reducer) => ({
      ...reducer,
      [LOCATION_CHANGE]: (state, action) => {
        return Object.assign({}, state, {
          error: null,
          isFetching: false,
          setTaskSuccess: undefined
        });
      }
    })
  )(configurations),
  {
    ...initialState
  }
);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/task/reducers.js